import { useEffect } from 'react';

const Web3Auth = ({ onUserId }) => {
    useEffect(() => {
        const initWeb3 = async () => {
            if (window.ethereum) {
                try {
                    const accounts = await window.ethereum.request({ method: "eth_accounts" });
                    if (accounts && accounts[0] && onUserId) {
                        onUserId(accounts[0]);
                    }
                } catch (error) {
                    console.error("Could not read wallet account", error);
                }
            } else {
                console.error("Web3 provider not detected. Please install MetaMask.");
            }
        };

        initWeb3();
    }, [onUserId]);

    return null; // This component doesn’t render any UI
};

export default Web3Auth;
